import React from "react"
import "./styles.scss"

export class Sidebar extends React.Component {
  state = {
    activeSlug: "default",
  }

  themes = [
    { slug: "default", name: "Sem tema (Padrão)" },
    { slug: "ame-minha-conta", name: "Minha Conta (light)" },
    { slug: "ame-minha-conta-dark", name: "Minha Conta (Dark)" },
    { slug: "ame-empresas", name: "Empresas (Light)" },
    { slug: "ame-empresas-dark", name: "Empresas (Dark)" },
    { slug: "lasa", name: "Americanas-SIS (Light)" },
    { slug: "lasa-dark", name: "Americanas-SIS (Dark)" },
  ]

  changeTheme = slug => {
    const body = document.querySelector("body")
    body.setAttribute("class", slug)
    this.setState({
      activeSlug: slug,
    })
  }

  render() {
    return (
      <aside className="sidebar">
        {this.themes.map(x => (
          <button
            key={x.slug}
            className={`btn ${
              this.state.activeSlug === x.slug ? "active" : ""
            }`}
            onClick={() => {
              this.changeTheme(x.slug)
            }}>
            {x.name}
          </button>
        ))}
      </aside>
    )
  }
}
